import { themeBackgrounds } from "@dana/MobiusOverrides/styles/colors";
import { fontSizes, lineHeights } from "@dana/MobiusOverrides/styles/typography";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { onePageCheckoutPaymentDetailsStyles } from "@insite/content-library/Widgets/OnePageCheckout/OnePageCheckoutPaymentDetails";
import { css } from "styled-components";

onePageCheckoutPaymentDetailsStyles.paymentDetailsGridContainer = mergeToNew(
    onePageCheckoutPaymentDetailsStyles.paymentDetailsGridContainer,
    {
        gap: 0,
        css: css`
            background: ${themeBackgrounds.white};
        `,
    },
);

onePageCheckoutPaymentDetailsStyles.paymentDetailsHeadingGridItem = mergeToNew(
    onePageCheckoutPaymentDetailsStyles.paymentDetailsHeadingGridItem,
    {
        width: 12,
        css: css`
            background: ${themeBackgrounds.lightGray};
            padding: 16px;
        `,
    },
);

onePageCheckoutPaymentDetailsStyles.paymentDetailsHeadingText = mergeToNew(
    onePageCheckoutPaymentDetailsStyles.paymentDetailsHeadingText,
    {
        transform: "capitalize",
        size: fontSizes.medium,
        lineHeight: lineHeights.medium,
        css: css`
            margin-bottom: 0;
            letter-spacing: normal;
        `,
    },
);

onePageCheckoutPaymentDetailsStyles.paymentdMethodInfoGridItem = mergeToNew(
    onePageCheckoutPaymentDetailsStyles.paymentdMethodInfoGridItem,
    {
        css: css`
            padding: 16px;
        `,
    },
);

onePageCheckoutPaymentDetailsStyles.poNumberGridItem = mergeToNew(
    onePageCheckoutPaymentDetailsStyles.poNumberGridItem,
    {
        width: [12, 6, 6, 6, 6],
    },
);

onePageCheckoutPaymentDetailsStyles.vatNumberGridItem = mergeToNew(
    onePageCheckoutPaymentDetailsStyles.vatNumberGridItem,
    {
        width: [12, 6, 6, 6, 6],
    },
);
